import { useCallback, useEffect, useRef } from "react";
import {
  trackButtonClick as trackAnalyticsButtonClick,
  trackPageView,
  trackUserAction as trackAnalyticsUserAction,
} from "../utils/analytics";

const normalizePromoTrackingInput = (eventIdOrOptions, eventName) =>
  typeof eventIdOrOptions === "object"
    ? eventIdOrOptions
    : {
        eventId: eventIdOrOptions,
        pageTitle: eventName,
      };

export const usePromoTracking = (eventIdOrOptions, eventName) => {
  const {
    eventId,
    pageTitle,
    serialNumber,
    guestId,
    location,
  } = normalizePromoTrackingInput(eventIdOrOptions, eventName);
  const hasTrackedPageView = useRef(false);

  useEffect(() => {
    if (hasTrackedPageView.current || !pageTitle) {
      return;
    }

    trackPageView({
      pageTitle,
      eventId,
      serialNumber,
      guestId,
      location,
    });
    hasTrackedPageView.current = true;
  }, [eventId, guestId, location, pageTitle, serialNumber]);

  const trackButtonClick = useCallback(
    (buttonNameOrOptions, buttonLocation = "") => {
      const trackingOptions =
        typeof buttonNameOrOptions === "string"
          ? {
              buttonName: buttonNameOrOptions,
              location: buttonLocation,
            }
          : buttonNameOrOptions || {};

      trackAnalyticsButtonClick({
        eventId,
        serialNumber,
        guestId,
        ...trackingOptions,
      });
    },
    [eventId, guestId, serialNumber],
  );

  const trackUserAction = useCallback(
    (userActionOrOptions, details = {}) => {
      const trackingOptions =
        typeof userActionOrOptions === "string"
          ? {
              userAction: userActionOrOptions,
              ...details,
            }
          : userActionOrOptions || {};

      trackAnalyticsUserAction({
        eventId,
        serialNumber,
        guestId,
        ...trackingOptions,
      });
    },
    [eventId, guestId, serialNumber],
  );

  return {
    trackButtonClick,
    trackUserAction,
  };
};
